var map = {
	"./Apps.svg": "6a15",
	"./Arrow.svg": "122e",
	"./ArrowGray.svg": "79c4",
	"./ArrowWhite.svg": "b042",
	"./Bag.svg": "8143",
	"./BannerEmpty.svg": "e019",
	"./BannerFilled.svg": "3775",
	"./BlueDoubleCheck.svg": "5724",
	"./Briefcase.svg": "c1f9",
	"./Calendar.svg": "7c8b",
	"./ChevronDown.svg": "5195",
	"./Clip.svg": "5bd9",
	"./Clock.svg": "8e6f",
	"./Collab.svg": "7f10",
	"./Connection.svg": "b623",
	"./Copy.svg": "3b35",
	"./DoubleCheck.svg": "e957",
	"./Download.svg": "c831",
	"./Edit.svg": "3efa",
	"./EmptyFile.svg": "4bc7",
	"./Envelope.svg": "be75",
	"./Eye.svg": "dba80",
	"./EyeSlash.svg": "27a1",
	"./GraduationCap.svg": "31f8",
	"./Grid.svg": "0bbc",
	"./Hamburger.svg": "01c7",
	"./HamburgerClose.svg": "5089",
	"./HeartEmpty.svg": "1c62",
	"./HeartFull.svg": "5870",
	"./Help.svg": "6208",
	"./Home.svg": "51c5",
	"./Info.svg": "90b8",
	"./Link.svg": "d05e",
	"./LinkChain.svg": "e4f6",
	"./List.svg": "ef45",
	"./Notification.svg": "870f",
	"./PenToSquare.svg": "3a9f",
	"./Phone.svg": "828b",
	"./Place.svg": "ad20",
	"./Plus.svg": "6f54",
	"./Resources.svg": "3828",
	"./Search.svg": "8196",
	"./Settings.svg": "2ddc",
	"./Speaker.svg": "a161",
	"./SquareStar.svg": "0f6a",
	"./Text.svg": "0f76",
	"./Tool.svg": "ad8a",
	"./Trash.svg": "8b5d",
	"./Trophy.svg": "74a9",
	"./TrophyFill.svg": "09a9",
	"./UserGroup.svg": "24d4",
	"./Users.svg": "a899",
	"./Video.svg": "7990",
	"./X.svg": "020b",
	"./checkboxX.svg": "a043",
	"./toast-x-icon.svg": "597e",
	"./toastXIconWhite.svg": "951b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";